import { IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowTrendUp, faArrowTrendDown } from '@fortawesome/free-solid-svg-icons';

export default function StatCard({
  label,
  value,
  icon,
  iconBg = '#eff6ff',
  iconColor = '#2563eb',
  trend,
}: {
  label: string;
  value: string | number;
  icon?: IconDefinition;
  iconBg?: string;
  iconColor?: string;
  trend?: { value: string; positive: boolean };
}) {
  return (
    <div className="bg-white border border-gray-100 rounded-lg shadow-sm p-5 flex items-start justify-between">
      <div>
        <p className="text-[12px] font-bold text-gray-500 uppercase tracking-wide mb-2">{label}</p>
        <p className="text-[26px] font-black text-gray-900 tracking-tight leading-none">{value}</p>
        {trend && (
          <p
            className="text-[11px] font-bold mt-2 flex items-center gap-1"
            style={{ color: trend.positive ? '#16a34a' : '#dc2626' }}
          >
            <FontAwesomeIcon
              icon={trend.positive ? faArrowTrendUp : faArrowTrendDown}
              style={{ fontSize: 11 }}
            />
            {trend.value}
          </p>
        )}
      </div>
      {icon && (
        <div
          className="w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0"
          style={{ background: iconBg }}
        >
          <FontAwesomeIcon icon={icon} style={{ color: iconColor, fontSize: 16 }} />
        </div>
      )}
    </div>
  );
}